import { render, staticRenderFns } from "./prize-detail.vue?vue&type=template&id=734b5f74&scoped=true"
import script from "./prize-detail.vue?vue&type=script&lang=js"
export * from "./prize-detail.vue?vue&type=script&lang=js"
import style0 from "./prize-detail.vue?vue&type=style&index=0&id=734b5f74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734b5f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734b5f74')) {
      api.createRecord('734b5f74', component.options)
    } else {
      api.reload('734b5f74', component.options)
    }
    module.hot.accept("./prize-detail.vue?vue&type=template&id=734b5f74&scoped=true", function () {
      api.rerender('734b5f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/components/prize-detail.vue"
export default component.exports